import CalendarDate from '@untitled-ui/icons-react/build/esm/CalendarDate';

import { Button, DatePicker } from 'antd';
import { endOfDay, isWithinInterval, parseISO, startOfDay } from 'date-fns';
import dayjs from 'dayjs';

export type DateRange = [Date, Date] | null;

interface DateRangeFilterProps {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

export const DateRangeFilter = ({ value, onChange }: DateRangeFilterProps) => (
  <div className="column-menu-panel">
    <DatePicker.RangePicker
      format="DD/MM/YYYY"
      placeholder={['From', 'To']}
      suffixIcon={<CalendarDate className="h-4 text-gray-700" />}
      value={value ? [dayjs(value[0]), dayjs(value[1])] : null}
      onChange={(dates) =>
        onChange(dates?.[0] && dates?.[1] ? [dates[0].toDate(), dates[1].toDate()] : null)
      }
      // Nothing can have been updated in the future.
      disabledDate={(date) => date.isAfter(dayjs().endOf('day'))}
      // Keep the calendar inside the column menu. Rendered in the body it counts as an
      // outside click and closes the menu the moment a date is picked.
      getPopupContainer={(trigger) => trigger.parentElement ?? document.body}
      className="w-full"
    />

    <Button type="link" size="small" className="px-0" disabled={!value} onClick={() => onChange(null)}>
      Clear
    </Button>
  </div>
);

/** Keeps records whose date falls within `range`, inclusive of both whole days. */
export const filterByDateRange = <TRecord,>(
  data: TRecord[] | undefined,
  getDate: (record: TRecord) => string | undefined,
  range: DateRange
) => {
  if (!range) return data;

  const [start, end] = range;

  return data?.filter((record) => {
    const date = parseISO(getDate(record) ?? '');

    return (
      !Number.isNaN(date.getTime()) &&
      isWithinInterval(date, { start: startOfDay(start), end: endOfDay(end) })
    );
  });
};
